import React from 'react';

import { getDescriptionDic, getTitleDic } from '../../functions';
import KortbetjeningModal from '../../kortbetjening-modal/KortbetjeningModal';
import { RegionRule, SiteCoreDictionary } from '../../types';

interface InfoModalProps {
    showModal: boolean;
    setShowModal: (value: boolean) => void;
    regions: RegionRule[];
    dictionary: SiteCoreDictionary;
}

export default ({ showModal, setShowModal, regions, dictionary }: InfoModalProps) => {
    const descName = getDescriptionDic(dictionary);
    const titleName = getTitleDic(dictionary);

    return (
        <KortbetjeningModal
            id="card-action"
            appNamespace="block-region-info"
            open={showModal}
            setOpen={() => setShowModal(false)}
            shouldCloseOnOverlayClick
        >
            <article className="information-wrapper">
                <h1>{dictionary.regionInformation}</h1>
                {regions.map(({ region }) => (
                    <div className="region-info" key={region.id}>
                        <h3>{titleName[region.id]}</h3>
                        <p>{descName[region.id]}</p>
                    </div>
                ))}
            </article>
        </KortbetjeningModal>
    );
};
